module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB4003-1cc1083c87525b07bdd6baeaf905498a.png";